




























import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase';

@Component({
  components: {
  },
})
export default class App extends Vue {
  private logout() {
    firebase.auth().signOut().then(() => {
      this.$router.push('/signin');
    });
  }
}
